import React from 'react';
import { Typography } from "../../ecosystem";
import { connect } from "react-redux";

const NoManagersMsg = ({
    message,
    removeBSWPharmacy
}) => {

    return (
        <div className="no-managers-msg-container">
            <Typography
                type="body-01"
                color="$color-seconday-a2"
                tag="div"
            >
                No managers are set up.
            </Typography>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};
export default connect(mapStateToProps, null)(NoManagersMsg);


